import axios from "axios";
import { useState } from "react";
import { toastMessage } from "utils/toastMessageHelper";

export const useLinkDownloader = () => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadLinkFile = async ({
    apiHandler,
    fileName,
    getFileFrom,
    params,
  }) => {
    try {
      setIsLoading(true);
      const sendData = {
        ...params,
        responseType: "blob",
      };

      const response = await apiHandler(sendData);

      const { data, message, status } = response;

      if (status === 200) {
        toastMessage("success", message, "linkFileDownload");

        const fileUrl = data[getFileFrom];
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      }
      // Additional error handling logic, if needed
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, downloadLinkFile };
};
